export const REVIEWED_SERVICE_CODES = new Set([
    'S-01', 'SRM-01', 'S-02', 'S-03', 'S-04', 'S-05', 'S-06', 'S-07', 'S-12', 'S-13', 'S-14', 'S-15', 'S-16',
]);

export const evidenceCollection = (code: string): string | null => ({
    'S-01': 's01_assessments', 'SRM-01': 's01_assessments',
    'S-02': 's02_facility_plans', 'S-03': 's03_staff_protection_plans',
    'S-04': 's04_event_security_plans', 'S-05': 'intelligence_service_deliveries',
    'S-06': 'intelligence_service_deliveries', 'S-07': 'intelligence_service_deliveries',
    'S-12': 'intelligence_service_deliveries',
    'S-13': 's13_crisis_management_plans', 'S-14': 's14_business_resiliency_plans',
    'S-15': 's15_hsse_audits',
    'S-16': 's16_emergency_preparedness_plans',
} as Record<string, string>)[code] || null;

export const reviewField = (code: string): string => ({
    'S-01': 's01Review', 'SRM-01': 's01Review', 'S-02': 's02Review',
    'S-03': 's03Review', 'S-04': 's04Review', 'S-13': 's13Review', 'S-14': 's14Review',
    'S-15': 's15Review',
    'S-16': 's16Review',
} as Record<string, string>)[code] || 'intelligenceReview';

export const evidenceEditable = (status: string, code: string, reviewStatus: string) =>
    REVIEWED_SERVICE_CODES.has(code) && ['submitted', 'in_review', 'in_progress', 'awaiting_delivery', 'information_requested'].includes(status)
    && (reviewStatus !== 'Approved' || code === 'S-04');

export const serviceConversationEditable = (service: any) => service.recall?.state === 'active'
    && ['in_progress', 'awaiting_delivery'].includes(service.status)
    || evidenceEditable(service.status, service.serviceCode, service[reviewField(service.serviceCode)]?.status || '');
